// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-page-wrapper {
    min-height: calc(100vh - 70px);
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 20px 40px;
    background-color: var(--bg-app);
}

.create-card {
    width: 100%;
    max-width: 500px;
    background-color: var(--bg-card);
    padding: 40px;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-card);
    border: 1px solid var(--border-light);
    animation: slideUp 0.4s ease-out;
    position: relative;
}

@keyframes slideUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
}

.form-header {
    text-align: center;
    margin-bottom: 30px;
}

.form-header h1 {
    font-size: 1.75rem;
    font-weight: 800;
    color: var(--brand-primary);
    margin: 0 0 8px 0;
}

.form-header p {
    color: var(--text-muted);
    font-size: 0.95rem;
    margin: 0;
}

.create-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.form-group label {
    display: block;
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--text-main);
    margin-bottom: 6px;
}

.form-control {
    width: 100%;
    height: 50px;
    padding: 0 16px;
    background-color: var(--bg-input);
    border: 1px solid var(--border-light);
    border-radius: var(--radius-input);
    font-size: 1rem;
    color: var(--text-main);
    transition: var(--transition);
    box-sizing: border-box;
    font-family: inherit;
}

.form-control:focus {
    outline: none;
    background-color: #fff;
    border-color: var(--brand-primary);
    box-shadow: var(--shadow-input-focus);
}

textarea.form-control {
    height: auto;
    min-height: 100px;
    padding: 12px 16px;
    resize: vertical;
}

.form-row {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 16px;
}

@media (max-width: 480px) {
    .form-row {
        grid-template-columns: 1fr;
    }

    .create-card {
        padding: 24px;
    }
}

.btn-submit {
    width: 100%;
    height: 54px;
    margin-top: 10px;
    background-color: var(--brand-primary);
    color: #fff;
    border: none;
    border-radius: var(--radius-input);
    font-size: 1.1rem;
    font-weight: 700;
    cursor: pointer;
    transition: var(--transition);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.btn-submit:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0,0,0,0.2);
    filter: brightness(1.1);
}

.btn-submit:disabled {
    background-color: #CBD5E1;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.error-banner {
    background-color: #FEF2F2;
    border: 1px solid #FECACA;
    color: var(--error);
    padding: 12px;
    border-radius: var(--radius-md);
    margin-bottom: 20px;
    text-align: center;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CreateAmericana.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,8BAA8B;IAC9B,qCAAqC;IACrC,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iCAAiC;IACjC,qCAAqC;IACrC,kCAAkC;IAClC,eAAe;IACf,uBAAuB;IACvB,6BAA6B;IAC7B,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,uCAAuC;IACvC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ","sourcesContent":[".create-page-wrapper {\n    min-height: calc(100vh - 70px);\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 30px 20px 40px;\n    background-color: var(--bg-app);\n}\n\n.create-card {\n    width: 100%;\n    max-width: 500px;\n    background-color: var(--bg-card);\n    padding: 40px;\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-card);\n    border: 1px solid var(--border-light);\n    animation: slideUp 0.4s ease-out;\n    position: relative;\n}\n\n@keyframes slideUp {\n    from { opacity: 0; transform: translateY(20px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.form-header {\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.form-header h1 {\n    font-size: 1.75rem;\n    font-weight: 800;\n    color: var(--brand-primary);\n    margin: 0 0 8px 0;\n}\n\n.form-header p {\n    color: var(--text-muted);\n    font-size: 0.95rem;\n    margin: 0;\n}\n\n.create-form {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.form-group label {\n    display: block;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: var(--text-main);\n    margin-bottom: 6px;\n}\n\n.form-control {\n    width: 100%;\n    height: 50px;\n    padding: 0 16px;\n    background-color: var(--bg-input);\n    border: 1px solid var(--border-light);\n    border-radius: var(--radius-input);\n    font-size: 1rem;\n    color: var(--text-main);\n    transition: var(--transition);\n    box-sizing: border-box;\n    font-family: inherit;\n}\n\n.form-control:focus {\n    outline: none;\n    background-color: #fff;\n    border-color: var(--brand-primary);\n    box-shadow: var(--shadow-input-focus);\n}\n\ntextarea.form-control {\n    height: auto;\n    min-height: 100px;\n    padding: 12px 16px;\n    resize: vertical;\n}\n\n.form-row {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    gap: 16px;\n}\n\n@media (max-width: 480px) {\n    .form-row {\n        grid-template-columns: 1fr;\n    }\n\n    .create-card {\n        padding: 24px;\n    }\n}\n\n.btn-submit {\n    width: 100%;\n    height: 54px;\n    margin-top: 10px;\n    background-color: var(--brand-primary);\n    color: #fff;\n    border: none;\n    border-radius: var(--radius-input);\n    font-size: 1.1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: var(--transition);\n    box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\n.btn-submit:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px rgba(0,0,0,0.2);\n    filter: brightness(1.1);\n}\n\n.btn-submit:disabled {\n    background-color: #CBD5E1;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n.error-banner {\n    background-color: #FEF2F2;\n    border: 1px solid #FECACA;\n    color: var(--error);\n    padding: 12px;\n    border-radius: var(--radius-md);\n    margin-bottom: 20px;\n    text-align: center;\n    font-size: 0.9rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
